import mobile from "./mobile.svg";
import frontend from "./frontend.svg";
import backend from "./backend.svg";
import integration from "./integration.svg";
import cloud from "./cloud.svg";
import data from "./databases.svg";
import devops from "./devops.svg";
import quality from "./quality.svg";

const images = {
  DevOps: devops,
  "Data Engineering": data,
  "Quality Engineering": quality,
  "Cloud & Platforms": cloud,
  Integration: integration,
  Backend: backend,
  Frontend: frontend,
  Mobile: mobile,
};

export default images;
